import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { bool, func, string } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const EvidenceExportPasswordDialog = ({ open, onClose, password = '', filename = '', onCopy }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>{I18n.t('AdminEvidenceExportScene.PasswordDialogTitle')}</DialogTitle>
    <DialogContent>
      <Alert severity="warning" sx={{ mb: 2 }}>
        {I18n.t('AdminEvidenceExportScene.PasswordWarning')}
      </Alert>
      <TextField
        fullWidth
        multiline
        minRows={2}
        value={password || ''}
        slotProps={{ input: { readOnly: true } }}
        onFocus={e => e.target.select()}
        helperText={
          filename
            ? I18n.t('AdminEvidenceExportScene.PasswordInstructions', { file: filename })
            : undefined
        }
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={() => {
          if (password) {
            navigator.clipboard.writeText(password);
          }
          if (onCopy) onCopy();
        }}
      >
        {I18n.t('AdminEvidenceExportScene.CopyPassword')}
      </Button>
      <Button variant="contained" onClick={onClose}>
        {I18n.t('AdminEvidenceExportScene.Close')}
      </Button>
    </DialogActions>
  </Dialog>
);

EvidenceExportPasswordDialog.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
  password: string,
  filename: string,
  onCopy: func,
};

export default EvidenceExportPasswordDialog;
